import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

const AdmissionLetterLandingPage = () => {
    const componentRef = useRef(null); // ✅ Create a ref for the printable content

    const handlePrint = useReactToPrint({
        content: () => componentRef.current, // ✅ Ensure ref is returned correctly
        documentTitle: "Admission Letter",
        onAfterPrint: () => console.log("Printed successfully!"),
    });

    const printAdmission = () => {
        if (!componentRef.current) {
            console.error("❌ Nothing to print: componentRef is null!");
            return;
        }else{
            console.error(componentRef.current)
        }
        handlePrint();
    };

    return (
        <div>
            {/* ✅ Button triggers print */}
            <button onClick={printAdmission} className="btn btn-primary">
                Print Admission Letter
            </button>

            {/* ✅ The content to print */}
            <div ref={componentRef} style={{ background: "white", padding: "20px" }}>
                <h1>Test Print</h1>
                <p>This is a test admission letter.</p>
            </div>
        </div>
    );
};

export default AdmissionLetterLandingPage;
